// extracted by mini-css-extract-plugin
export default {"shared":"\"../../shared.module.css\"","md":"768px","container":"Credits_container__zEYMl","item":"Credits_item__SyHGY","tooltip":"Credits_tooltip__l+RYj"};